import BlockText from './BlockText';

export default BlockText;
